import { Label } from "components/common/label/Label";
import { type Color } from "../../common/BaseLabel/BaseLabel";

export interface PackPrivateLabelProps {
  isPrivate: boolean;
}

export const PackPrivateLabel: React.FC<PackPrivateLabelProps> = (props) => {
  const { isPrivate } = props;

  const text = isPrivate ? "private" : "public";

  return <Label basic {...getLabelProps(isPrivate)} text={text.toUpperCase()} />;
};

const getLabelProps = (isPrivate: boolean): { color: Color; icon?: string } =>
  isPrivate ? { color: "gray", icon: "fa-lock" } : { color: "darker-green", icon: "fa-lock-open" };
